module.exports = __webpack_public_path__ + "6020-shadow.33057f2e1c7522f248026e958f9816ef.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6020-shadow.png
// module id = 189
// module chunks = 0